import { TextField } from '@mui/material';
import { fmtDate } from '@/lib/date';
import { textFieldProps } from '../textFieldProps';
import type { FieldComponentProps, FieldTypeSpec } from '../types';

export interface DateConfig { min?: string; max?: string }

/** Dates stay ISO strings (YYYY-MM-DD, or YYYY-MM for months) — the shape the API sends and expects. */
function makeDateInput(inputType: 'date' | 'month') {
  return function DateInput({ field, value, onChange, onBlur, error }: FieldComponentProps<string | null, DateConfig>) {
    const base = textFieldProps(field, error);
    return (
      <TextField {...base} type={inputType} value={value ?? ''} onBlur={onBlur}
                 onChange={(e) => onChange(e.target.value || null)}
                 slotProps={{
                   ...base.slotProps,
                   htmlInput: { min: field.config.min, max: field.config.max, ...(base.slotProps?.htmlInput as object) },
                 }} />
    );
  };
}

export const dateTypes: Record<string, FieldTypeSpec> = {
  date: { component: makeDateInput('date'), display: (v) => fmtDate(v as string) },
  month: {
    component: makeDateInput('month'),
    display: (v) => new Date(`${v as string}-01`).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }),
  },
};
